<!--
  Migrated `submissions-dasboard.submission.submit` view. Renders the
  TEST/PRODUCTION radio + Submit/Get-Ack/Ping buttons (legacy submit.html)
  and the IRS Submissions Status grid that the legacy `.submit.history`
  child state mounted via `<ui-view>` (efile.js L89-120 + EfileService.js
  `submissionListColumns`).
-->

<div class="submit-action__top">
  <!--
    Conditional info banners — port of submit.html L104-113. Driven by
    `pendingSubmission` and `pendingCriticalDiagnostics` which the legacy
    SubmitController populated via $rootScope events from the IRS-status
    grid (action_code=81j7mv) and critical-diag check (action_code=787b9e).
  -->
  @if (pendingSubmission) {
<div class="submission-details-text mt-10 mb-10">
    <div class="highlighted-text">
      Submission is prepared for eFile to IRS and is in review by the eFile Team. A member of the eFile team will proceed with the IRS submission if no issues are found and will inform you of any errors encountered.
    </div>
  </div>
}
  @if (pendingCriticalDiagnostics) {
<div class="submission-details-text mt-10 mb-10">
    <div class="highlighted-text">
      Submission has pending Critical Diagnostics that need to be resolved before proceeding with submission to the IRS.
    </div>
  </div>
}

  <!--
    TEST / PRODUCTION radios — PRODUCTION is gated by `canDoProdSubmit`
    (submit.html L116, SubmitController L710-711).
  -->
  <div class="options">
    <input type="radio" id="envType-test" name="envType" value="TEST" [(ngModel)]="envType">
    <label for="envType-test">TEST</label>
    @if (canDoProdSubmit) {
<input
           type="radio"
           id="envType-prod"
           name="envType"
           value="PRODUCTION"
           [(ngModel)]="envType">
}
    @if (canDoProdSubmit) {
<label for="envType-prod">PRODUCTION</label>
}
  </div>

  <!--
    Action buttons — Submit / Get Acknowledgment swap based on `onlyGetAck`
    (submit.html L119-142). Submit's label flips to "Prepare Submission"
    when env=PRODUCTION on a non-extension return.
  -->
  <div class="actions w-100 text-center mt-10">
    @if (!onlyGetAck) {
<button
            class="btn btn-primary btn-submit"
            type="button"
            [disabled]="isSubmitDisabled"
            [title]="pendingSubmission ? 'Please resolve the below submission before proceeding with the next submission' : ''"
            (click)="submit()">
      {{ submitButtonLabel }}
      @if (submitting) {
<span><i class="fa fa-spinner fa-spin"></i></span>
}
    </button>
}
    @if (onlyGetAck) {
<button
            class="btn btn-primary btn-submit"
            type="button"
            [disabled]="acking"
            (click)="getAck()">
      Get Acknowledgment
      @if (acking) {
<span><i class="fa fa-spinner fa-spin"></i></span>
}
    </button>
}
  </div>
</div>

<div class="submit-action__history">
  <div class="history-toolbar">
    <div class="toolbar-left">
      <button type="button"
              class="history-tool"
              title="Print"
              [disabled]="loadingSubmissions"
              (click)="printHistory()">
        <i class="fa fa-print"></i>
      </button>
      <button type="button"
              class="history-tool"
              title="Excel"
              [disabled]="loadingSubmissions"
              (click)="exportHistoryToExcel()">
        <i class="fa fa-file-excel-o"></i>
      </button>
    </div>
    <div class="toolbar-right">
      <label class="search-label">
        Search:
        <input type="text"
               class="search-input"
               [ngModel]="searchTerm"
               (ngModelChange)="onSearchChange($event)"
               placeholder="" />
      </label>
    </div>
  </div>

  <div class="submissions-status-table-scroll">
    <table class="submissions-status-table">
      <thead>
        <tr>
          @for (col of submissionColumns; track $index) {
<th
              class="sortable"
              [class.sorted]="sortKey === col.data"
              (click)="toggleSort(col.data)"
              (keyup.enter)="toggleSort(col.data)"
              tabindex="0"
              role="button"
              [attr.aria-label]="'Sort by ' + col.title">
            <span>{{ col.title }}</span>
            <i class="sort-icon" [ngClass]="sortIconClass(col.data)" aria-hidden="true"></i>
          </th>
}
          <th class="actions-col">Actions</th>
        </tr>
      </thead>
      <tbody>
        @for (row of filteredSubmissions; track trackByIrs($index, row)) {
<tr>
          @for (col of submissionColumns; track $index) {

            @if (!col.downloadType && !col.isDate) {
<td>{{ formatCell(row, col) }}</td>
}
            @if (col.isDate) {
<td class="col-submitted-date">{{ formatCell(row, col) }}</td>
}
            @if (col.downloadType) {
<td>
              @if (row[col.data]) {

                <a class="download-link"
                   [class.text-red]="isAckRed(col, row[col.data])"
                   (click)="downloadFile(col.downloadType!, row.IRS_ID)">
                  {{ row[col.data] }}
                </a>
              
} @else {
—
}
              
            </td>
}
          
}

          <!--
            Actions column — port of EfileService.js `renderActions`
            (L109-134). The column is suppressed entirely for TEST rows
            (`hasRowActions`) and degrades to a single `View` link for
            users who lack `canDoProdSubmit`. The full review workflow
            (Upload / Complete Review / Reject / Send To IRS) only shows
            when the row is PRODUCTION and the user can submit to prod.
          -->
          <td class="actions-cell">
            @if (hasRowActions(row)) {

              @if (showView(row)) {

                <a class="action-link" (click)="onRowView(row)">View</a>
              
}
              @if (showUpload(row)) {

                <a class="action-link" (click)="onRowUpload(row)">Upload</a>
                @if (showReviewActions(row)) {

                  <span class="sep">/</span>
                  <a class="action-link" (click)="markAsReviewed(row.IRS_ID)">Complete Review</a>
                  <span class="sep">/</span>
                  <a class="action-link text-red" (click)="discardReturn(row.IRS_ID)">Reject</a>
                
}
                @if (showSendToIRS(row)) {

                  <span class="sep">/</span>
                  @if (isRowSubmitting(row)) {
<span
                        class="row-submitting">
                    <i class="fa fa-spinner fa-spin"></i>
                  </span>
} @else {

                    <a class="action-link" (click)="onRowSendToIRS(row)">Send To IRS</a>
                  
}
                  
                
}
              
}
            
} @else {
<span class="dash-cell">—</span>
}
            
          </td>
        </tr>
}

        @if (!loadingSubmissions && filteredSubmissions.length === 0) {
<tr>
          <td [attr.colspan]="submissionColumns.length + 1" class="empty-cell">
            @if (submissionsError) {
<span>{{ submissionsError }}</span>
} @else {
No submission history available.
}
            
          </td>
        </tr>
}

        @if (loadingSubmissions) {
<tr>
          <td [attr.colspan]="submissionColumns.length + 1" class="loading-cell">
            <i class="fa fa-spinner fa-spin"></i> Loading...
          </td>
        </tr>
}
      </tbody>
    </table>
  </div>
</div>

<!--
  Confirm dialog for Reject / Mark-as-Reviewed actions and the PRODUCTION
  two-step submit confirmation (legacy `openConfirmation` in
  `EfileElementsController.js`). Rendered through the shared
  `<gtw-confirmation-modal>` so the look matches every other efile confirm
  flow (return-review, scrubbing, efile-setup, key-xml-gen, ...).
-->
@if (showConfirm) {
<gtw-confirmation-modal
 
  [config]="confirmConfig"
  [visible]="false"
  (confirmed)="onConfirm()"
  (cancelled)="onCancelConfirm()"
  (closed)="onCancelConfirm()">
</gtw-confirmation-modal>
}

<!--
  Mandatory header elements review modal — port of
  `reqHeaderElements.html`. Opened by the submit chain after the optional
  tax-doc upload. Proceed advances to the PROD double-confirm (or directly
  to `doSubmit` when TEST).
-->
@if (showReqHeaderModal) {
<div
     class="submit-action__modal-overlay"
     (click)="onReqHeaderCancel()">
  <div class="submit-action__modal-dialog submit-action__modal-dialog--lg"
       (click)="$event.stopPropagation()">
    <gtw-efile-req-header-elements
      [submissionIdOverride]="rowData?.SUBMISSION_ID"
      [submitTypeOverride]="envType"
      (proceed)="onReqHeaderProceed()"
      (request-grid-update)="onReqHeaderCancel()">
    </gtw-efile-req-header-elements>
  </div>
</div>
}

<!--
  Review attachment upload modal — port of `upload-review-attachments.html`.
  Reused for three flows:
    1. PRODUCTION submit prep (mode='prepare') — captures S3 file key
       into `taxDocUrl` then chains into the header review modal.
    2. IRS grid `Upload` action (mode='upload') against a specific IRS row.
    3. IRS grid `View` action (mode='view') — read-only.
-->
@if (showAttachmentModal) {
<div
     class="submit-action__modal-overlay modal-warning"
     (click)="closeAttachmentModal()">
  <div class="submit-action__modal-dialog"
       (click)="$event.stopPropagation()">
    <div class="submit-action__modal-header">
      <h4>{{ attachmentModalTitle }}</h4>
      <i class="fa fa-times pull-right hoverable" (click)="closeAttachmentModal()"></i>
    </div>
    <div class="submit-action__modal-body submit-action__modal-body--attachment gtw-web-components">
      @if (reviewAttachmentUploadInputJson) {
<gtw-efile-review-attachment-upload
       
        [efile-review-attachment-upload-input]="reviewAttachmentUploadInputJson"
        [isReadOnlyModeOverride]="attachmentModalReadOnly"
        (on-efile-review-attachment-upload)="onAttachmentUploaded($event)">
      </gtw-efile-review-attachment-upload>
}
    </div>
  </div>
</div>
}
